import * as React from "react";
import { Chip, useTheme } from "@mui/material";
import { ActivityState } from "./ActivityState";

type Props = {
  activityState: ActivityState;
  disabled?: boolean;
};

export default function StateAsChip({ activityState, disabled }: Props) {
  const theme = useTheme();

  const getColorForState = (state: ActivityState) => {
    switch (state) {
      case "Active":
        return theme.palette.success.main;
      case "New":
        return theme.palette.warning.main;
      case "Expired":
        return theme.palette.secondary.main;
      default:
        return theme.palette.grey[100];
    }
  };

  return (
    <Chip
      label={activityState}
      style={{
        backgroundColor: getColorForState(activityState),
        color: theme.palette.primary.contrastText,
        height: "20px",
        fontSize: "12px",
      }}
      disabled={disabled}
    />
  );
}
